import React from 'react'
import { useSelector } from 'react-redux'
import EntityBoard from 'components/HealthcareSearch/EntityBoard'

/**
 * Applicant-embedded Healthcare Search — one row per entity (the business and each owner from the
 * already-loaded application), each searched and tracked on its own. The standalone Quick Search
 * page keeps the single-form HealthcareSearch component.
 */
const HealthcareSearchTabContent = ({ applicantId, creditCosts }) => {
    const business = useSelector(state => state?.applicant?.applicantById?.business)
    const owners = useSelector(state => state?.applicant?.applicantById?.owners)

    return (
        <EntityBoard
            applicantId={applicantId}
            creditCosts={creditCosts}
            business={business}
            owners={owners || []}
        />
    )
}

export default HealthcareSearchTabContent
